import { create } from 'zustand';

import type { HttpClient } from '../lib/types';

export type { HttpClient };

interface HttpStoreValue {
	data: HttpClient | null;
	rcs: HttpClient | null;
	v1: HttpClient | null;
	v2: HttpClient | null;
}

export type HttpClientKey = keyof HttpStoreValue;

export const useHttpStore = create<HttpStoreValue>(() => ({
	data: null,
	rcs: null,
	v1: null,
	v2: null,
}));
